import { createContext, useRef, useContext } from 'react';

const GraphRefContext = createContext();

export const GraphRefProvider = ({ children }) => {
  const graphRef = useRef(null);
  return (
    <GraphRefContext.Provider value={graphRef}>
      {children}
    </GraphRefContext.Provider>
  );
};

export const useGraphRef = () => useContext(GraphRefContext);